const AMC_CLP_PAGE_PATH = "/investments/funds";

const trimTrailingSlashes = (path: string): string => {
  let end = path.length;
  while (end > 0 && path[end - 1] === "/") {
    end -= 1;
  }
  return end === path.length ? path : path.slice(0, end);
};

/** True when pathname is the AMC CLP page (web, app-v1, or versioned routes). */
export const isAmcClpPage = (pathname: string): boolean => {
  const normalized = trimTrailingSlashes(pathname) || "/";
  return (
    normalized === AMC_CLP_PAGE_PATH ||
    normalized.endsWith(AMC_CLP_PAGE_PATH) ||
    normalized.includes(`/app-v1${AMC_CLP_PAGE_PATH}`)
  );
};
